var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogContent } from "@mui/material";
import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
import { useModal } from "../../../../Shared/components/Modal";
import { ModalActionButton, ModalActions, ModalLoadingButton } from "../../../../Shared/components/modalTemplates";
import { useRecipes } from "../../../OrderFlowProvider/OrderFlow.requests";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { ModuleNames, RecipeTypeSelectionMode, } from "../../../OrderFlowProvider/OrderFlowTypes";
import { RecipeTypeText } from "./recipeType-types";
const handleRecipeTypeChange = (modelRecipeTypes, cartRecipeType, clearRecipesOnRecipeTypeChanged, recipeTypeSelectMode, cartMeals, cartTemplate, model, showModal, applyRecipeTypeUpcharge, dispatch) => (recipeTypeId) => {
    const recipeType = modelRecipeTypes.find((rt) => rt.recipeTypeId === recipeTypeId);
    if (!cartRecipeType || cartRecipeType.recipeTypeId != (recipeType === null || recipeType === void 0 ? void 0 : recipeType.recipeTypeId)) {
        const recipeAssignments = cartMeals
            .map((meal) => meal.RecipeAssignments)
            .filter((assignment) => assignment !== null);
        if (recipeAssignments.length > 0 && clearRecipesOnRecipeTypeChanged != null) {
            const warningModalText = clearRecipesOnRecipeTypeChanged.TextValue;
            showModal({
                title: "Recipe Type Change Warning",
                content: (_jsx(DialogContent, { children: _jsx("p", { children: warningModalText ? warningModalText : RecipeTypeText.WarningModalDefaultText }) })),
                actions: (_jsxs(ModalActions, { children: [_jsx(ModalActionButton, Object.assign({ color: "secondary", variant: "outlined" }, { children: "Cancel" })), _jsx(ModalLoadingButton, Object.assign({ color: "secondary", variant: "contained", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                dispatch({ type: ActionTypes.SET_RECIPE_TYPE, payload: recipeType });
                                /**
                                 * Remove any remaining recipes on meals.
                                 * This is done prior to passing to applyRecipeTypeUpcharge to prevent unnecessary computations
                                 */
                                const removedAssignmentFromCartMeals = cartMeals === null || cartMeals === void 0 ? void 0 : cartMeals.map((meal) => (Object.assign(Object.assign({}, meal), { RecipeAssignments: [] })));
                                const { updatedCartMeals, updatedProgramMeals, updatedTemplate } = applyRecipeTypeUpcharge(model, cartRecipeType, recipeType, removedAssignmentFromCartMeals, cartTemplate);
                                /**
                                 * It's important to dispatch SET_MEALS before SET_TEMPLATE.
                                 * This is because inside the reducer case for SET_TEMPLATE, we execute a function getMealsFromTemplate
                                 * and update meals in addition to template.
                                 * getMealsFromTemplate relies on accurate meal data from the store, therefore SET_MEALS is executed first.
                                 */
                                dispatch({ type: ActionTypes.SET_MEALS, payload: updatedCartMeals });
                                dispatch({ type: ActionTypes.SET_TEMPLATE, payload: updatedTemplate });
                                dispatch({ type: ActionTypes.SET_PROGRAM_MEALS, payload: updatedProgramMeals });
                                if (recipeTypeSelectMode != RecipeTypeSelectionMode.Filter) {
                                    dispatch({
                                        type: ActionTypes.SET_RECIPE_FETCH_STATUS,
                                        payload: { completed: false, error: false },
                                    });
                                }
                                return true;
                            }) }, { children: "Confirm" }))] })),
            });
        }
        else {
            const { updatedCartMeals, updatedProgramMeals, updatedTemplate } = applyRecipeTypeUpcharge(model, cartRecipeType, recipeType, cartMeals, cartTemplate);
            /**
             * It's important to dispatch SET_MEALS before SET_TEMPLATE.
             * This is because inside the reducer case for SET_TEMPLATE, we execute a function getMealsFromTemplate
             * and update meals in addition to template.
             * getMealsFromTemplate relies on accurate meal data from the store, therefore SET_MEALS is executed first.
             */
            dispatch({ type: ActionTypes.SET_MEALS, payload: updatedCartMeals });
            dispatch({ type: ActionTypes.SET_TEMPLATE, payload: updatedTemplate });
            dispatch({ type: ActionTypes.SET_PROGRAM_MEALS, payload: updatedProgramMeals });
            dispatch({ type: ActionTypes.SET_RECIPE_TYPE, payload: recipeType });
            if (recipeTypeSelectMode != RecipeTypeSelectionMode.Filter) {
                dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
            }
        }
    }
};
/**
 * useRecipeType - Handles changing recipe type and filtering recipe types to display
 * @param moduleConfig
 * @returns
 */
export const useRecipeType = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const { showModal } = useModal();
    const { applyRecipeTypeUpcharge } = useRecipes();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.RECIPE_TYPE &&
        module.Sequence === sequenceNumber &&
        module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    return {
        sliderSettings: SliderSettings(moduleConfig.ScreenLG, moduleConfig.ScreenMD, moduleConfig.ScreenSM, moduleConfig.ScreenXS),
        IsGridLayout: moduleConfig.IsGridLayout,
        showDescription: moduleConfig.ShowDescription,
        CardDescriptionLines: moduleConfig.CardDescriptionLines,
        showImage: moduleConfig.ShowImage,
        imageHeight: moduleConfig.ImageHeight,
        recipeTypeDisplayMode: moduleConfig.RecipeTypeDisplayMode,
        imageBaseUrl: store.model.RecipeTypeImageBaseUrl,
        noRecipeTypesToDisplay: !store.model.RecipeTypes || store.model.RecipeTypes.length === 0,
        selectedRecipeType: store.cart.recipeType,
        cardsPerRowXS: moduleConfig.ScreenXS,
        cardsPerRowSM: moduleConfig.ScreenSM,
        cardsPerRowMD: moduleConfig.ScreenMD,
        cardsPerRowLG: moduleConfig.ScreenLG,
        gridSpacing: moduleConfig.GridSpacing,
        recipeTypesToRender: store.model.RecipeTypes.filter((recipeType) => {
            if (!moduleConfig.ExcludedRecipeTypes) {
                return true;
            }
            return !moduleConfig.ExcludedRecipeTypes.includes(recipeType.recipeTypeId);
        }),
        handleRecipeTypeChange: handleRecipeTypeChange(store.model.RecipeTypes, store.cart.recipeType, moduleConfig.ClearRecipesOnRecipeTypeChanged, moduleConfig.RecipeTypeSelectionMode, store.cart.meals, store.cart.template, store.model, showModal, applyRecipeTypeUpcharge, dispatch),
        CenterCards: moduleConfig.CenterCards,
    };
};
